import {awsConfig} from '../../shared/config';
import * as RestURI from '../../shared/RestURI';

import * as Consts from '../../components/constants/Consts';
import * as RestCallHelper from './RestCallHelper';
import { getAuthorizedWorksitesForEmployer } from '../auth/Security';


export const fetchReminders = (clientId, startDate, endDate) => {

    const urlParams = new URLSearchParams({ clientId: clientId, startDate: startDate, endDate: endDate});
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.REMINDERS}?${urlParams}`);

    return RestCallHelper.fetchAsJson(url);
}


export const fetchCalendarItemsForClient = (clientId, authzWorksites, startDate, endDate) => {
    const urlParams = new URLSearchParams({ clientId: clientId, startDate: startDate, endDate: endDate});
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.CALENDAR}?${urlParams}`);

    return RestCallHelper.fetchAsJson(url)
        .then(iterms => {
            if(!authzWorksites) {
                return iterms;
            }
            else{
                return iterms.filter(item => (item.type === Consts.CALENDAR_EVENT_TYPE_REMINDER && authzWorksites.includes( item.extra.worksiteId )) ||
                                      (item.type === Consts.CALENDAR_EVENT_TYPE_RSVTITASK && item.details.activeStep > 1 && authzWorksites.includes( item.step1.workSiteId ))
                                    )
            }
        })
}


export const fetchAuthzIscirDocument = (authzType, docType, clientId, taskId) => {
    const urlParams = new URLSearchParams({ authzType: authzType, documentType: docType, clientId: clientId, taskId: taskId});
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.DOC_ISCIR}?${urlParams}`);

    return RestCallHelper.fetchAsDocument(url);
}


export const fetchAuthzIntDocument = (authzType, docType, clientId, taskId) => {
    const urlParams = new URLSearchParams({ authzType: authzType, documentType: docType, clientId: clientId, taskId: taskId});
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.DOC_INTERNAL}?${urlParams}`);

    return RestCallHelper.fetchAsDocument(url);
}


export const fetchDocTest = (rsvtiOperator, authzType, employerId, workSiteId) => {
    const urlParams = new URLSearchParams({ rsvtiOperatorUname: rsvtiOperator, 
                                            authzType: authzType 
                                            // employerId: employerId, 
                                            // workSiteId: workSiteId
                                          });
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.DOC_TESTS}?${urlParams}`);

    return RestCallHelper.fetchAsDocument(url);
}


export const fetchAuthzImage = (imageKey) => {
    const urlParams = new URLSearchParams({ imageKey: imageKey });
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.AUTHZS_ISCIR_IMAGE}?${urlParams}`);

    return RestCallHelper.fetchAsImage(url);
}


export const fetchAuthzCertUrl = (documentKey) => {
    const urlParams = new URLSearchParams({ documentKey: documentKey });
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.AUTHZS_INTERNAL_CERT}?${urlParams}`);

    return RestCallHelper.fetchAsJson(url);
}


export const fetchCourseCertUrl = (documentKey) => {
    const urlParams = new URLSearchParams({ documentKey: documentKey });
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.EMPLOYEES_COURSES_CERT}?${urlParams}`);

    return RestCallHelper.fetchAsJson(url);
}


export const fetchCourseCert = (documentKey) => {
    const urlParams = new URLSearchParams({ documentKey: documentKey });
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.EMPLOYEES_COURSES_CERT}?${urlParams}`);

    return RestCallHelper.fetchAsPdf(url);
}


export const fetchReport = (reportType, authzType, workSiteId) => {
    const urlParams = new URLSearchParams({ reportType: reportType, authzType: authzType, workSiteId: workSiteId});
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.REPORT_WORKSITE_DESERVENTI}?${urlParams}`);

    return RestCallHelper.fetchAsJson(url);
}


export const fetchClients = () => {
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.CLIENTS}`);

    return RestCallHelper.fetchAsJson(url);
}


export const fetchUsers = (clientId) => {
    const urlParams = new URLSearchParams({ clientId: clientId });
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.USERS}?${urlParams}`);

    return RestCallHelper.fetchAsJson(url);
}


export const fetchEmployerWorksites = (employerId) => {
    const urlParams = new URLSearchParams({ employerId: employerId });
    const authzWorksites = getAuthorizedWorksitesForEmployer(employerId);

    if(authzWorksites) {
        urlParams.append("wslist", authzWorksites);
    }

    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.WORKSITES}?${urlParams}`);    

    return RestCallHelper.fetchAsJson(url);
}


export const fetchAllWorksitesForClient = (clientId) => {
    const urlParams = new URLSearchParams({ clientId: clientId });

    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.WORKSITES}?${urlParams}`);    

    return RestCallHelper.fetchAsJson(url);
}


export const fetchAllEmployersForClient = (clientId) => {
    const urlParams = new URLSearchParams({ clientId: clientId });

    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.EMPLOYERS}?${urlParams}`);    

    return RestCallHelper.fetchAsJson(url);
}


export const fetchRsvtiOperators = (clientId, worksiteId) => {
    const params = {
        functionName: 'getRsvtiOperators',
        clientId: clientId,
        worksiteId: worksiteId
    };    
    const urlParams = new URLSearchParams(params);

    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.QUERY}?${urlParams}`);    

    return RestCallHelper.fetchAsJson(url);
}


export const sendCourseRegistrationEmail = (email) => {
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.EMAIL_COURSE_REGISTRATION}`);

    return RestCallHelper.postAsJson(url, email);
}
